var map = {
	"./Spin360_TorreOvaloD_001.jpg": 20028,
	"./Spin360_TorreOvaloD_002.jpg": 46698,
	"./Spin360_TorreOvaloD_003.jpg": 59239,
	"./Spin360_TorreOvaloD_004.jpg": 68066,
	"./Spin360_TorreOvaloD_005.jpg": 1139,
	"./Spin360_TorreOvaloD_006.jpg": 89256,
	"./Spin360_TorreOvaloD_007.jpg": 82041,
	"./Spin360_TorreOvaloD_008.jpg": 2121,
	"./Spin360_TorreOvaloD_009.jpg": 35839,
	"./Spin360_TorreOvaloD_010.jpg": 76720,
	"./Spin360_TorreOvaloD_011.jpg": 72138,
	"./Spin360_TorreOvaloD_012.jpg": 53656,
	"./Spin360_TorreOvaloD_013.jpg": 33762,
	"./Spin360_TorreOvaloD_014.jpg": 64203,
	"./Spin360_TorreOvaloD_015.jpg": 57378,
	"./Spin360_TorreOvaloD_016.jpg": 24485,
	"./Spin360_TorreOvaloD_017.jpg": 4245,
	"./Spin360_TorreOvaloD_018.jpg": 21743,
	"./Spin360_TorreOvaloD_019.jpg": 98957,
	"./Spin360_TorreOvaloD_020.jpg": 56962,
	"./Spin360_TorreOvaloD_021.jpg": 33897,
	"./Spin360_TorreOvaloD_022.jpg": 14615,
	"./Spin360_TorreOvaloD_023.jpg": 86026,
	"./Spin360_TorreOvaloD_024.jpg": 97452,
	"./Spin360_TorreOvaloD_025.jpg": 45195,
	"./Spin360_TorreOvaloD_026.jpg": 13530,
	"./Spin360_TorreOvaloD_027.jpg": 16090,
	"./Spin360_TorreOvaloD_028.jpg": 15488,
	"./Spin360_TorreOvaloD_029.jpg": 6771,
	"./Spin360_TorreOvaloD_030.jpg": 51815,
	"./Spin360_TorreOvaloD_031.jpg": 24920,
	"./Spin360_TorreOvaloD_032.jpg": 59602,
	"./Spin360_TorreOvaloD_033.jpg": 98146,
	"./Spin360_TorreOvaloD_034.jpg": 64864,
	"./Spin360_TorreOvaloD_035.jpg": 87622,
	"./Spin360_TorreOvaloD_036.jpg": 5520,
	"./Spin360_TorreOvaloD_037.jpg": 43045,
	"./Spin360_TorreOvaloD_038.jpg": 94960,
	"./Spin360_TorreOvaloD_039.jpg": 99743,
	"./Spin360_TorreOvaloD_040.jpg": 1815,
	"./Spin360_TorreOvaloD_041.jpg": 92418,
	"./Spin360_TorreOvaloD_042.jpg": 80337,
	"./Spin360_TorreOvaloD_043.jpg": 66033,
	"./Spin360_TorreOvaloD_044.jpg": 37349,
	"./Spin360_TorreOvaloD_045.jpg": 40504,
	"./Spin360_TorreOvaloD_046.jpg": 45711,
	"./Spin360_TorreOvaloD_047.jpg": 81566,
	"./Spin360_TorreOvaloD_048.jpg": 36810,
	"./Spin360_TorreOvaloD_049.jpg": 87378,
	"./Spin360_TorreOvaloD_050.jpg": 82091,
	"./Spin360_TorreOvaloD_051.jpg": 26846,
	"./Spin360_TorreOvaloD_052.jpg": 39677,
	"./Spin360_TorreOvaloD_053.jpg": 22572,
	"./Spin360_TorreOvaloD_054.jpg": 99762,
	"./Spin360_TorreOvaloD_055.jpg": 62585,
	"./Spin360_TorreOvaloD_056.jpg": 33309,
	"./Spin360_TorreOvaloD_057.jpg": 83235,
	"./Spin360_TorreOvaloD_058.jpg": 68452,
	"./Spin360_TorreOvaloD_059.jpg": 70408,
	"./Spin360_TorreOvaloD_060.jpg": 86172,
	"./Spin360_TorreOvaloD_061.jpg": 85531,
	"./Spin360_TorreOvaloD_062.jpg": 16332,
	"./Spin360_TorreOvaloD_063.jpg": 80045,
	"./Spin360_TorreOvaloD_064.jpg": 56004,
	"./Spin360_TorreOvaloD_065.jpg": 78905,
	"./Spin360_TorreOvaloD_066.jpg": 29199,
	"./Spin360_TorreOvaloD_067.jpg": 52291,
	"./Spin360_TorreOvaloD_068.jpg": 3761,
	"./Spin360_TorreOvaloD_069.jpg": 60101,
	"./Spin360_TorreOvaloD_070.jpg": 36027,
	"./Spin360_TorreOvaloD_071.jpg": 63658,
	"./Spin360_TorreOvaloD_072.jpg": 2211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50412;